<template>
  <div class="row">
    <div class="col col-md-6 col-sm-12 form-group">
      <div class="p-1 mt-4 mx-1 rounded  align-content-end border border-success">
        <h5 class="mb-3">{{ $t('FileExport.export') }}</h5>
        <button type="button"
                style="font-size: 1em;"
                class="m-2 btn btn-sm btn-outline-success"
                @click="exportToCSV">
          <i class="bi bi-filetype-csv"></i>
          {{ $t('FileExport.asCSV') }}
        </button>
        <button type="button"
                style="font-size: 1em;"
                class="m-2 btn btn-sm btn-outline-success"
                @click="exportToExcel">
          <i class="bi bi-filetype-xlsx"></i>
          {{ $t('FileExport.asExcel') }}
        </button>
        <button type="button"
                style="font-size: 1em;"
                class="m-2 btn btn-sm btn-outline-success"
                @click="exportToPdf">
          <i class="bi bi-filetype-pdf"></i>
          {{ $t('FileExport.asPDF') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import {saveAs} from "file-saver";
import {jsPDF} from "jspdf";
import {autoTable} from "jspdf-autotable";

export default {
  props: {
    filename: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    }
  },
  methods: {
    exportToExcel() {
      if (this.data !== null) {
        try {
          const worksheet = XLSX.utils.json_to_sheet(this.data);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
          });

          saveAs(
              new Blob([excelBuffer], {type: "application/octet-stream"}),
              this.filename + ".xlsx"
          );
        } catch (exception) {
          console.error(exception);
        }
      } else {
        console.error("Data to export is null");
      }
    },
    exportToCSV() {
      if (this.data !== null) {
        try {
          const worksheet = XLSX.utils.json_to_sheet(this.data);
          const csv = XLSX.utils.sheet_to_csv(worksheet);
          const blob = new Blob([csv], {type: "text/csv;charset=utf-8"});
          saveAs(blob, this.filename + ".csv");
        } catch (exception) {
          console.error(exception);
        }
      } else {
        console.error("Data to export is null");
      }
    },
    exportToPdf() {

      if (this.data !== null) {
        try {
          console.log(this.data)
          const doc = new jsPDF({
            orientation: 'l',
            unit: "mm",
            format: "a4",
            putOnlyUsedFonts: true
          });

          const columnNames = Object.keys(this.data[0]).filter(name => name !== "id" && name !== "__id");
          let columnData = [];
          this.data.forEach(entry => {
            let row = [];
            columnNames.forEach(column => {
              if (column === "normalized_indicator_value") {
                row.push(entry[column].toFixed(2));
              } else if (column === "role") {
                row.push(entry[column]['name']);
              } else {
                row.push(entry[column]);
              }
            });
            columnData.push(row);
          });

          autoTable(doc, {
            head: [columnNames.map(value => {
              return value.replaceAll('_', ' ');
            })],
            body: columnData,
          });
          doc.save(this.filename + ".pdf");
        } catch (exception) {
          console.error(exception);
        }
      } else {
        console.error("Data to export is null");
      }
    },
  }
};
</script>
